export default __webpack_public_path__ + "static/media/Crossbow of Ardashir Garrison.54b046f2.jpg";